import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { Box, TableCell, TableHead, TableRow, TableSortLabel, Typography, Tooltip } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'

const useStyles = makeStyles((theme) => ({
  iconContainer: {
    display: 'inline',
    marginLeft: theme.spacing(0.5),
  },
  tableSortLabel: {
    position: 'relative',
    top: '-2px',
  },
}))

const Tip = ({ text }) => {
  const styles = useStyles()
  return (
    <Tooltip
      title={text}
      aria-label={text}
    >
      <Box className={styles.iconContainer}>
        <FontAwesomeIcon
          icon={faInfoCircle}
          color="#007DAA"
        />
      </Box>
    </Tooltip>
  )
}
Tip.propTypes = {
  text: PropTypes.string.isRequired,
}

const DashTableHeader = ({ columns, order, orderBy, onRequestSort }) => {
  const styles = useStyles()

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property)
  }

  return (
    <TableHead>
      <TableRow>
        {columns.map((column) => (
          <TableCell
            className={column.headerStyle}
            key={column.id}
            align={column.align || 'left'}
            sortDirection={orderBy === column.id ? order : false}
          >
            {column.enableSort ? (
              <TableSortLabel
                active={orderBy === column.id}
                direction={orderBy === column.id ? order : 'asc'}
                onClick={createSortHandler(column.id)}
                className={styles.tableSortLabel}
              >
                <Fragment>
                  <Typography component="span">
                    <strong>{column.label}</strong>
                  </Typography>
                  {column.tooltip && <Tip text={column.tooltip} />}
                </Fragment>
              </TableSortLabel>
            ) : (
              <Fragment>
                <Typography component="span">
                  <strong>{column.label}</strong>
                </Typography>
                {column.tooltip && <Tip text={column.tooltip} />}
              </Fragment>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

DashTableHeader.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      enableSort: PropTypes.bool,
      header: PropTypes.bool,
      headerStyle: PropTypes.any,
    }),
  ).isRequired,
  order: PropTypes.oneOf(['asc', 'desc']),
  orderBy: PropTypes.string,
  onRequestSort: PropTypes.func,
  headerStyle: PropTypes.any,
}

export default DashTableHeader
